import React from 'react';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const MICRO = 'block text-[10px] font-semibold uppercase tracking-[0.1em] text-muted mb-1';

// Filter bar for the Time Entry table. Pure presentation: state lives in usePersistedFilters.
export default function EntryFilterBar({
  values, onChange, onReset, activeKeys, resultCount,
  searchQuery, onSearchChange,
  categories, clients, people, users, departments, years,
}) {
  const base = 'w-full text-[12.5px] text-ink bg-surface border rounded-tc-sm px-3 py-2 min-h-[38px]';
  const cls = (key) => `${base} ${activeKeys.includes(key) ? 'border-accent ring-1 ring-accent' : 'border-line'}`;
  const sel = (key, micro, allLabel, items) => (
    <label className="block">
      <span className={MICRO}>{micro}</span>
      <select
        aria-label={micro}
        value={values[key]}
        onChange={(e) => onChange(key, e.target.value)}
        className={cls(key)}
      >
        <option value="">{allLabel}</option>
        {items.map((item) => (
          <option key={item.value} value={item.value}>{item.label}</option>
        ))}
      </select>
    </label>
  );
  const plain = (list) => list.map((v) => ({ value: v, label: v }));

  return (
    <div className="mb-4">
      <div className="flex flex-wrap items-end gap-3 mb-3">
        {sel('filterCategory', 'Category', 'All categories', categories.map((c) => ({ value: c.name, label: c.name })))}
        <label className="block flex-1 min-w-[12rem]">
          <span className={MICRO}>Search</span>
          <input
            type="text"
            aria-label="Search"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search project or client"
            className={`${base} border-line`}
          />
        </label>
        {sel('filterClient', 'Client', 'All clients', clients.map((c) => ({ value: c.name, label: c.name })))}
        {sel('filterRequestedBy', 'Requested by', 'All people', people.map((p) => ({ value: p.name, label: p.name })))}
        {sel('filterDepartment', 'Department', 'All departments', plain(departments))}
        <label className="block">
          <span className={MICRO}>Year</span>
          <select
            aria-label="Year"
            value={values.filterYear}
            onChange={(e) => onChange('filterYear', e.target.value)}
            className={cls('filterYear')}
          >
            <option value="">All years</option>
            {years.map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
        </label>
        {sel('filterMonth', 'Month', 'All months', MONTHS.map((m, i) => ({ value: String(i + 1).padStart(2, '0'), label: m })))}
        {sel('filterUser', 'User', 'All users', plain(users))}
      </div>
      <button
        type="button"
        onClick={onReset}
        className="bg-surface text-muted text-[12.5px] border border-line rounded-tc-sm px-3.5 min-h-[38px]"
      >
        Reset filters · {resultCount} results{activeKeys.length > 0 ? ` (${activeKeys.length})` : ''}
      </button>
    </div>
  );
}
